var map = {
	"./carouselForItemDetailsConstants.js": 64,
	"./carsouselForAvatarPageConstants.js": 65,
	"./carsouselForInventoryConstants.js": 66,
	"./itemListConstants.js": 67,
	"./recommendationsConstants.js": 68
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 63;